<script lang="ts">
	import type { HTMLAttributes } from 'svelte/elements';

	let props: HTMLAttributes<SVGElement> = $props();
</script>

<svg viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
	<path
		d="M16.75 6.25H14.25V4.375C14.25 3.38044 13.8549 2.42661 13.1517 1.72335C12.4484 1.02009 11.4946 0.625 10.5 0.625C9.50544 0.625 8.55161 1.02009 7.84835 1.72335C7.14509 2.42661 6.75 3.38044 6.75 4.375V6.25H4.25C3.91848 6.25 3.60054 6.3817 3.36612 6.61612C3.1317 6.85054 3 7.16848 3 7.5V16.25C3 16.5815 3.1317 16.8995 3.36612 17.1339C3.60054 17.3683 3.91848 17.5 4.25 17.5H16.75C17.0815 17.5 17.3995 17.3683 17.6339 17.1339C17.8683 16.8995 18 16.5815 18 16.25V7.5C18 7.16848 17.8683 6.85054 17.6339 6.61612C17.3995 6.3817 17.0815 6.25 16.75 6.25ZM8 4.375C8 3.71196 8.26339 3.07607 8.73223 2.60723C9.20107 2.13839 9.83696 1.875 10.5 1.875C11.163 1.875 11.7989 2.13839 12.2678 2.60723C12.7366 3.07607 13 3.71196 13 4.375V6.25H8V4.375Z"
		fill="currentColor"
	/>
</svg>
